import { Button, Dialog, Divider } from "@rio-cloud/rio-uikit";

interface ISuccessDialogProps {
    show: boolean;
    title: string;
    body: string | React.ReactNode;
    footer?: React.ReactNode;
    showCloseButton?: React.ReactNode;
    onClose: () => void;
}

const SuccessDialog = ({ show, title, body, footer, showCloseButton = true, onClose }: ISuccessDialogProps) => {
    return (
        <Dialog
            show={show}
            title={(
                <div className="">
                    <span className="rioglyph rioglyph-ok-sign margin-right-10 text-color-success" />
                    <span>{title}</span>
                </div>
            )}
            footer={
                <div className='display-flex justify-content-end space-x-4'>
                    {footer}
                    {showCloseButton && (
                        <div>
                            <Button bsStyle='default' onClick={onClose} className="margin-right-10">
                                Fechar
                            </Button>
                        </div>
                    )}
                </div>
            }
            body={body}
            bsSize={Dialog.SIZE_SM}
            onClose={onClose}
        />
    );
}

export default SuccessDialog;